export default __webpack_public_path__ + "static/media/5315.47e3b737.png";